export default __webpack_public_path__ + "7c6540bc0b.eot";